import { render, staticRenderFns } from "./StorageList.vue?vue&type=template&id=97c9b9dc&scoped=true"
import script from "./StorageList.vue?vue&type=script&lang=js"
export * from "./StorageList.vue?vue&type=script&lang=js"
import style0 from "./StorageList.vue?vue&type=style&index=0&id=97c9b9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c9b9dc",
  null
  
)

export default component.exports